import * as Yup from 'yup'

export const providerSchema = Yup.object().shape({
  name: Yup.string()
    .max(50, 'Name must be less than 50 characters')
    .matches(/^[A-Za-z0-9 ]+$/, 'Only Alpha-Numeric Values Allowed')
    .required('Provider Name Required'),
  gameAggregatorId: Yup.string()
    .required('Aggregator Required'),
  thumbnail: Yup.mixed().required('A file is required')
    .test('File Size',
      'File Size Should be Less Than 1MB',
      (value) => !value || (value && value.size <= 1024 * 1024))
    .test('FILE_FORMAT', 'Uploaded file has unsupported format.',
      (value) => !value || (value && ['image/png', 'image/jpeg', 'image/jpg']
        .includes(value.type)))
})

export const editCategorySchema = Yup.object().shape({
  name: Yup.string()
    .max(50, 'Name must be less than 50 characters')
    .matches(/^[A-Za-z0-9 ]+$/, 'Only Alpha-Numeric Values Allowed')
    .required('Cat Required'),
  // thumbnail: Yup.mixed()
  //   .test('File Size',
  //     'File Size Should be Less Than 1MB',
  //     (value) => !value || (value && value.size <= 1024 * 1024))
  //   .test('FILE_FORMAT', 'Uploaded file has unsupported format.',
  //     (value) => !value || (value && ['image/png', 'image/jpeg', 'image/jpg']
  //       .includes(value.type)))
})

export const editSubCategorySchema = (name) => Yup.object().shape({
  name: validateName(name),
  subcategoryImage: Yup.mixed()
    // .required('Image Required')
    .test('File Size',
      'File Size Should be Less Than 1MB',
      (value) => typeof value === 'string' ? true : !value || (value && value.size <= 1024 * 1024))
    .test('FILE_FORMAT', 'Uploaded file has unsupported format.',
      (value) => typeof value === 'string' ? true : !value || (value && ['image/png', 'image/jpeg', 'image/jpg']
        .includes(value.type))),
  gameCategoryId: Yup.string()
    .required('Game Category Required'),

})

export const editproviderSchema = Yup.object().shape({
  name: Yup.string()
    .max(50, 'Name must be less than 50 characters')
    .matches(/^[A-Za-z0-9 ]+$/, 'Only Alpha-Numeric Values Allowed')
    .required('Provider Name Required'),
  thumbnail: Yup.mixed()
    .test('File Size',
      'File Size Should be Less Than 1MB',
      (value) => !value || (value && value.size <= 1024 * 1024))
    .test('FILE_FORMAT', 'Uploaded file has unsupported format.',
      (value) => !value || (value && ['image/png', 'image/jpeg', 'image/jpg']
        .includes(value.type)))
})

export const languageSchema = (name) => Yup.object().shape({
  name: validateName(name)
})


// export const categorySchema = Yup.object().shape({
//   name: Yup.string()
//     .trim()
//     .required('Category name is required'),

//   isActive: Yup.boolean()
//     .oneOf([true, false], 'Status is required')
//     .required('Status is required'),

//   image: Yup.mixed()
//     .required('Image is required')
//     .test(
//       'fileSize',
//       'File size must be less than or equal to 5MB',
//       value => value && value.size <= 5 * 1024 * 1024
//     )
// });

export const categorySchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("Category name is required"),

  isActive: Yup.boolean()
    .oneOf([true, false], "Status is required")
    .required("Status is required"),

  image: Yup.mixed()
    .required("Image is required")
    .test(
      "fileSize",
      "File size must be less than or equal to 5MB",
      (value) => {
        if (typeof value === "string") return true; // URL case
        return value && value.size <= 5 * 1024 * 1024;
      }
    )
    .test(
      "fileDimensions",
      "Image must be exactly 45x45 pixels",
      async (value) => {
        if (!value || typeof value === "string") return true; // Skip for URL
        const file = value instanceof File ? value : null;
        if (!file) return false;

        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
              resolve(img.width === 45 && img.height === 45);
            };
            img.onerror = () => resolve(false);
            img.src = e.target.result;
          };
          reader.readAsDataURL(file);
        });
      }
    ),

  gameLimit: Yup.number()
    .typeError("Game limit must be a number")
    .required("Game limit is required")
    .moreThan(0, "Game limit must be greater than 0"),
});






const validateName = (name) => {
  const validationObject = {}
  for (const file in name) {
    validationObject[file] = Yup.string()
      .required('Label Name Required!').nullable()
  }
  return Yup.object(validationObject)
}
